import { render, staticRenderFns } from "./BindAdminDialog.vue?vue&type=template&id=243bb0b4&"
import script from "./BindAdminDialog.vue?vue&type=script&lang=js&"
export * from "./BindAdminDialog.vue?vue&type=script&lang=js&"
import style0 from "./BindAdminDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports